import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from ':cloud/queries/types';
import { APIClientBase } from ':cloud/state/Api';
import { BaseL3Chain } from ':cloud/types/ts_types';

const errorMsg = 'Something went wrong. Please try again.';

async function createBaseL3({
  name,
  type,
  network,
  orgId,
  projectId,
  customGasToken,
  feeRecipient,
}: CreateBaseL3): Promise<BaseL3Chain> {
  const path = `/chain-manager/v1/organizations/${orgId}/projects/${projectId}/chains`;
  const body = {
    name,
    type,
    network,
    feeRecipient,
    customizations: { customGasToken },
  };

  const { data } = await APIClientBase.post<BaseL3Chain>(path, body);

  return data;
}

type CreateBaseL3 = {
  name: string;
  type: string;
  network: string;
  orgId?: string;
  projectId?: string;
  customGasToken?: string;
  feeRecipient?: string;
};

type UseCreateBaseL3Props = {
  orgId?: string;
  projectId?: string;
};

export function useCreateBaseL3({ orgId, projectId }: UseCreateBaseL3Props) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ name, type, network, customGasToken, feeRecipient }: CreateBaseL3) =>
      createBaseL3({ orgId, projectId, name, type, network, customGasToken, feeRecipient }),
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKey.baseL3, orgId, projectId]);
    },
    meta: {
      errorMsg,
    },
  });
}
